import { useDispatch, useSelector } from 'react-redux'

import { useText } from '@/components/i18n/hooks'
import Hits from '@/components/primitives/Hits'
import { getNumberOfCustomers, getTextFilter, setTextFilter } from '@/ducks/customersReducer'

const CustomersFilter = () => {
  const dispatch = useDispatch()

  const textFilter = useSelector(getTextFilter)
  const numberOfResults = useSelector(getNumberOfCustomers)

  const productFilterPlaceholderText = useText('filter customers')

  return (
    <>
      <input
        type="text"
        placeholder={productFilterPlaceholderText}
        value={textFilter}
        onChange={e => dispatch(setTextFilter(e.target.value))}
      />

      <Hits amount={numberOfResults} />
    </>
  )
}

export default CustomersFilter
